export enum shareableItemTypes {
    empty = 0,
    multicote = 1,
    agri_multicote_customize = 2,
    agri_multicote_ready_made = 3,
}

export enum multicoteNutrientTypes {
    "P2O5 K2O" = 0,
    "PK" = 1,
}
